import { Locale } from '@backmarket/http-api'
import { toBcp47Locale } from '@backmarket/utils/string/toBcp47Locale'

import { getLocaleFromPath } from './getLocaleFromPath'

/**
 * Replaces the locale in a URL path, or inserts it if not present.
 *
 * @param path - The original URL pathname (e.g., "/fr-fr/products")
 * @param newLocale - The new locale to apply (e.g., "en_US")
 * @returns A pathname with the locale replaced or prepended (e.g., "/en-us/products")
 */
export const replaceLocaleInPath = (
  path: string,
  newLocale: Locale,
): string => {
  const currentLocale = getLocaleFromPath(path)

  if (currentLocale) {
    return path.replace(`/${currentLocale}`, `/${toBcp47Locale(newLocale)}`)
  }

  return `/${toBcp47Locale(newLocale)}${path}`
}
